@if (logoUrl) {
  <img src="{{ logoUrl }}" alt="logotype" class="header__logo-img" />
}
@if (!logoUrl) {
  <p class="header__logo-name theme-header__beatmaker-name">{{ beatmakerName }}</p>
}
